import { Logger } from "@devforce/trailhead-client-logger";
export const PACKAGE_NAME = "@devforce/trailhead-client-auth";
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
export async function getAccessToken() {
    return state.accessTokenResolver();
}
export function hasAccessTokenResolver() {
    return state.accessTokenResolverSet;
}
export function setAccessTokenResolver(name, resolver) {
    state.accessTokenResolverSet = true;
    state.accessTokenResolver = () => {
        logger.info(`Running resolver "${name}"`);
        return resolver();
    };
}
async function defaultAccesTokenResolver() {
    return null;
}
let state = {
    accessTokenResolverSet: false,
    accessTokenResolver: defaultAccesTokenResolver,
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
